export const FORM_FIELDS = {
  NOM: "nom",
  PRENOM: "prenom",
  EMAIL: "email",
  PASSWORD: "password",
  CONFIRM_PASSWORD: "confirmPassword",
  CGU: "CGU",
  PHONE: 'numero'
} as const;
export const PASSWORD_MIN_LENGTH = 8;
export const VALIDATION_MESSAGES = {
  REQUIRED: {
    NOM: "Veuillez renseigner votre nom de famille.",
    PRENOM: "Veuillez renseigner votre prénom.",
    EMAIL: "Merci de fournir un mail",
    PASSWORD: "Merci de fournir un mot de passe",
    CONFIRM_PASSWORD: "Merci de confirmer votre mot de passe",
    CGU: "Merci de valider les conditions générales d'utilisation",
    PHONE: "Merci de fournir un numéro de téléphone",
  },
  INVALID: {
    EMAIL: "Veuillez fournir un mail valide",
    NOM: "Le nom de famille doit contenir uniquement des lettres et au moins 2 caractères.",
    PRENOM: "Le prénom doit contenir uniquement des lettres et au moins 2 caractères.",
    PASSWORD_MIN_LENGTH: (minLength: number) =>
      `Votre mot de passe doit contenir au moins ${minLength} caractères`,
    PASSWORD_MISMATCH: "Les mots de passe ne correspondent pas",
  },
};
